import type { FacetCount, KeycloakAuth, PageResult, StakedToken } from '$lib/types';
import type { AxiosInstance, AxiosResponse } from 'axios';
import { getDefaultAxios, getDefaultAxiosWithToken } from './AxiosService';

export class NFTStakingService {
	stakedNFTsURL = `/markets/stakedNFTs`;
	axios: AxiosInstance;
	keyCloack: KeycloakAuth | undefined;

	constructor(keyCloack?: KeycloakAuth) {
		if (keyCloack) {
			this.keyCloack = keyCloack;
			this.axios = getDefaultAxiosWithToken(keyCloack);
		} else {
			this.axios = getDefaultAxios();
		}
	}

	async batchInitOwnerShipOfStakedNFTs() {
		const resp = await this.axios.put<any, AxiosResponse<{ numberOfStakedNFTs: number }>, any>(
			`${this.stakedNFTsURL}/initOwnership`,
			{
				headers: {
					'Content-Type': 'application/json'
				}
			}
		);
		return resp;
	}

	async stakedTokens(tankNFTIds: string[]) {
		const resp = await this.axios.post<any, AxiosResponse<PageResult<StakedToken>>, any>(
			this.stakedNFTsURL,
			{
				tankNFTIds
			},
			{
				headers: {
					'Content-Type': 'application/json'
				},
				params: {
					first: 1000,
					skip: 0
				}
			}
		);
		return resp;
	}

	async unstakedTokens(tankNFTIds: string[]) {
		const resp = await this.axios.post<any, AxiosResponse<PageResult<StakedToken>>, any>(
			`${this.stakedNFTsURL}/unstake`,
			{
				tankNFTIds
			},
			{
				headers: {
					'Content-Type': 'application/json'
				},
				params: {
					first: 1000,
					skip: 0
				}
			}
		);
		return resp.data;
	}

	async GetStakedTokenByOwner(owner: string) {
		const resp = await this.axios.post<any, AxiosResponse<PageResult<StakedToken>>, any>(
			this.stakedNFTsURL + '/search',
			{
				ownerFrom: owner
			},
			{
				headers: {
					'Content-Type': 'application/json'
				},
				params: {
					first: 1000,
					skip: 0
				}
			}
		);
		return resp.data;
	}

	async GetStakedCountByOwner(address: string) {
		const resp = await this.axios.get<FacetCount[]>(
			`${this.stakedNFTsURL}/facet/network/count/owner/${address}`,
			{
				headers: {
					'Content-Type': 'application/json'
				}
			}
		);
		return resp.data;
	}
}
